const PrivacyPoliceData = [
  {
    title: 'Informasi yang Dikumpulkan',
    content: 'Kami mengumpulkan informasi pribadi seperti nama, nomor kontak, alamat email, dan riwayat layanan untuk keperluan administrasi dan pelayanan pelanggan.'
  },
  {
    title: 'Penggunaan Informasi',
    content: 'Data pribadi digunakan untuk proses reservasi, konfirmasi layanan, komunikasi promotional, dan pengembangan layanan pelanggan sesuai dengan izin yang Anda berikan.'
  },
  {
    title: 'Keamanan Data',
    content: 'Kami melindungi data pribadi Anda menggunakan teknologi enkripsi terkini, pembatasan akses, dan protokol keamanan yang ketat untuk mencegah akses tidak sah.'
  },
  {
    title: 'Pembagian Informasi',
    content: 'Kami tidak menjual atau menyewakan informasi pribadi Anda kepada pihak ketiga. Informasi hanya dapat dibagikan jika diperlukan untuk memberikan layanan atau sesuai dengan ketentuan hukum.'
  },
  {
    title: 'Hak Privasi Anda',
    content: 'Anda dapat meminta penghapusan, perubahan, atau mengakses data pribadi Anda kapan saja. Kami akan merespon permintaan Anda dalam waktu 30 hari.'
  },
  {
    title: 'Cookie dan Pelacakan',
    content: 'Kami menggunakan cookie untuk meningkatkan pengalaman pengguna, menganalisis lalu lintas situs, dan memberikan konten yang disesuaikan.'
  }
];

export default PrivacyPoliceData